@use "../../styles/breakpoint.module.scss" as *;

.root {
    grid-column: content;
    display: flex;
    flex-wrap: wrap;
    // The browser will default to correct gap based on whether it's a row or column
    gap: var(--spacer-16) var(--spacer-gutter);

    > * {
        flex-grow: 1;
        // "switcher" breakpoint (heydonworks)
        flex-basis: calc(($mobile - 100%) * 999);
    }
}

.column {
    padding: var(--spacer-32);
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16) var(--spacer-gutter);

    @media ($above-mobile) {
        .single & {
            flex-direction: row;
        }
    }
}

.media {
    @media ($above-mobile) {
        .single & {
            flex-basis: 50%;

            img {
                height: 100%;
                width: auto;
            }
        }
    }

    img {
        object-fit: cover;
        width: 100%;
        height: auto;
    }
}

.textWrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.eyebrow {
    composes: fontST20 from "../../styles/typography.module.scss";
    font-weight: bold;
    margin-bottom: var(--spacer-16);
}

.heading {
    composes: fontHB56 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-16);

    @media ($above-mobile) {
        .single & {
            font: var(--font-hb-80);
        }
    }
}

.subhead {
    composes: fontHB40 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-24);
}

.cta {
    margin-top: var(--spacer-40);
    color: var(--color-text);
}
